import { MutationHookOptions, useMutation } from '@apollo/client';

import { DELETE_CONSULTATION } from './mutations';

export const useDeleteConsultation = (options?: MutationHookOptions) => useMutation(DELETE_CONSULTATION, options);
